export const INVENTORY_TRANSFER_STATUSES = strings => ({
  pending: strings.pending,
  shipped: strings.shipped,
  delivered: strings.delivered,
  canceled: strings.canceled
})
